<template>
    <div class="autocomplete-wrapper">
        <input :class="[{'border-success selected': selected}]" @focus="show_dropdown = true" placeholder="Wpisz dane komornika" @blur="blurAutocomplete" v-model="ss_value" class="form-control"  />
        <button class="button btn autocomplete-clear btn-secondary" @click="clearAutocomplete" v-if="selected">X</button>
        <div class="dropdown-menu"
             :class="{active: show_dropdown}" v-if="options && options.length > 0">
            <div class="dropdown-content">
               <a   v-for="(option, index) in options"
                    v-if="index < 50"
                    :key="option.id"
                    @click.prevent="optionPickedHandler(option)"
                    class="dropdown-single">
                   <strong>{{ bailiff.name }}</strong>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import lodash from 'lodash';

    export default {
        name: "SsBailiffscomplete",
        components: {
            lodash,
        },
        props: {
            label: {
                type: String,
                default: ''
            },
            placeholder: {
              type: String,
              default: ''
            },
            clear: {
                type: Boolean,
                default: false
            },
            value: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            'type': {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                show_dropdown: false,
                ss_value: '',
                options: [],
                selected: '',
                uid: null
            }
        },
        mounted () {
            this.ss_value = this.value;
            this.uid = this._uid
        },
        computed: {
            hasValue(){
                return this.ss_value && this.ss_value.length > 0;
            },
        },
        methods: {
            blurAutocomplete(){
                if(!this.ss_value){
                    this.$emit('optionSelected', '');
                    this.selected = '';
                }
                setTimeout(()=>{this.show_dropdown = false}, 150);
            },
            filterContent: _.debounce(function(){
                axios.post('api/bailiff/get-bailiffs', { search: { name:  this.ss_value } }).then(response => {
                    this.options = response.data.data;
                });
            }, 500),
            clearAutocomplete(){
                this.ss_value = '';
                this.$emit('optionSelected', '');
                this.selected = '';
            },
            optionPickedHandler(option){
                this.show_dropdown = false;
                this.$emit('optionSelected', option);
                this.selected = option;
            },
        },
        watch: {
            ss_value(to){
                this.filterContent(to);
            },
            'value'(to){
                if(!to){
                    this.ss_value= to;
                }
                this.$forceUpdate();
            }
        }
    }
</script>
<style>
    .dropdown-content i{
        color: var(--blue);
    }
</style>
<style lang="scss" scoped>

    .dropdown-single i{
        font-style: normal;
        font-weight:bold;
    }
    .dropdown-single{
        display: block;
        width: 100%;
        padding: 0.25rem 1.5rem;
        clear: both;
        font-weight: 400;
        color: #151b1e;
        text-align: inherit;
        white-space: nowrap;
        background-color: transparent;
        border: 0;
        border-bottom: 1px #ccc solid;
        cursor: pointer;

        i{
            color: #007bff;
        }

        &:last-child{
            border-bottom: 0;
        }
        &:hover{
            background-color: #eaeaea;
        }
    }
    .dropdown-menu{
        right: 0;
        position: absolute;
        top: 35px;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 10rem;
        padding: 0 0;
        margin: 0;
        font-size: 0.875rem;
        color: #151b1e;
        text-align: left;
        list-style: none;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #c2cfd6;
        max-height: 22em;
        overflow: auto;
        i{
            color: #007bff;
        }
    }
    .dropdown-menu.active{
        display: block;
    }
    .autocomplete-wrapper{
        position: relative;
        display: flex;
        flex: 1;
        width: 100%;
        max-width: 300px;

        .selected{
            width: calc(100% - 42px);
        }
        .btn{
            width: 42px;
        }
    }
</style>
